export default function EFDryer(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="V1.2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="烘干机">
                    <rect id="矩形" x="0" y="0" width="44" height="44"></rect>
                    <g id="编组-56" transform="translate(9.000000, 4.000000)">
                        <rect id="矩形" stroke="currentColor" strokeWidth="1.6" x="0" y="0" width="26" height="35" rx="2.61925926"></rect>
                        <line x1="0" y1="6.48148148" x2="26" y2="6.48148148" id="路径-39" stroke="currentColor" strokeWidth="1.6"></line>
                        <rect id="矩形" fill="currentColor" fillRule="nonzero" x="2.6" y="2.91666667" width="5.85" height="1.2962963" rx="0.648148148"></rect>
                        <ellipse id="椭圆形" fill="currentColor" fillRule="nonzero" cx="19.175" cy="3.56481481" rx="1.3" ry="1.2962963"></ellipse>
                        <ellipse id="椭圆形备份-19" fill="currentColor" fillRule="nonzero" cx="22.425" cy="3.56481481" rx="1.3" ry="1.2962963"></ellipse>
                        <ellipse id="椭圆形" stroke="currentColor" strokeWidth="1.6" cx="13" cy="20.7407407" rx="9.1" ry="9.07407407"></ellipse>
                        <path
                            d="M8.45,16.0841232 L9.73998305,17.6053539 C10.4831095,18.4816962 10.3730869,19.7928189 9.49424073,20.5338281 C9.41169557,20.6034271 9.32384462,20.666516 9.23148329,20.7225236 C8.16388599,21.3699121 7.82473896,22.7577172 8.4739772,23.822273 C8.50294262,23.8697674 8.53365855,23.9161784 8.56606209,23.9614104 L9.36296657,25.0738088 L9.36296657,25.0738088"
                            id="路径-40"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M12.35,16.0841232 L13.639983,17.6053539 C14.3831095,18.4816962 14.2730869,19.7928189 13.3942407,20.5338281 C13.3116955,20.6034271 13.2238447,20.666516 13.1314833,20.7225236 C12.063886,21.3699121 11.724739,22.7577172 12.3739772,23.822273 C12.4029426,23.8697674 12.4336585,23.9161784 12.4660621,23.9614104 L13.2629666,25.0738088 L13.2629666,25.0738088"
                            id="路径-40备份"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                        ></path>
                        <path
                            d="M16.25,16.0841232 L17.539983,17.6053539 C18.2831095,18.4816962 18.1730869,19.7928189 17.2942407,20.5338281 C17.2116955,20.6034271 17.1238447,20.666516 17.0314833,20.7225236 C15.963886,21.3699121 15.624739,22.7577172 16.2739772,23.822273 C16.3029426,23.8697674 16.3336585,23.9161784 16.3660621,23.9614104 L17.1629666,25.0738088 L17.1629666,25.0738088"
                            id="路径-40备份-2"
                            stroke="currentColor"
                            strokeWidth="1.6"
                            strokeLinecap="round"
                        ></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
